import * as React from 'react';

import { observer } from 'mobx-react';

import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

import Ramp from './Ramp';

export const VulcanInStore = observer(({ translations = {}, config = {} }) => {
    const viewController = React.useMemo(
        () => diContainer.get(serviceNames.rampViewController),
        []
    );

    return <Ramp config={config} translations={translations} viewController={viewController} />;
});
